<template>
    <crud-facecade :url="url" :columns="columnList" :buttons="buttons" v-wechat-title="title" :tableHeight="tableHeight" :addButton="{}" :updateButton="{ enabled: false }"> </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `OrganizationOperationRoom`,
    props: {},
    data() {
        return {
            title: `组织架构-手术间`,
            url: {
                baseURL: `/api/AcisSystem/OperatingRoom`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get`)
                        req.then(data => {
                            resolve(
                                _.filter(data, d => {
                                    d.first_surgery_time = d.first_surgery_time != null ? d.first_surgery_time : that.$moment().format(`YYYY/MM/DD 08:00:00`)
                                    return _.some(this.operation_ward_auth, { value: d.dic_operating_ward_id })
                                })
                            )
                        }).catch(e => reject(e))
                    })
                }
            },
            buttons: []
        }
    },
    beforeMount() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`recovery_ward_auth`, `operation_ward_auth`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `code`,
                    label: `编码`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `alias`,
                    label: `别名`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`operation_ward_auth`],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `dic_recovery_ward_id`,
                    label: `复苏室`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`recovery_ward_auth`],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `abbr`,
                    label: `缩写`,
                    width: `100`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `description`,
                    label: `描述`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `bool`,
                    prop: `is_open`,
                    label: `是否开放`,
                    isListable: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_room_type`,
                    label: `手术间类型`,
                    width: `200`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.Enum_RoomType || []
                },
                {
                    type: `select`,
                    prop: `enum_isolation`,
                    label: `隔离状态`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.IsolationStatus || []
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    fixed: `right`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_allow_meantime_surgery`,
                    label: `允许多台`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `allow_device`,
                    label: `允许选择移动设备`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_merge_record`,
                    label: `是否合并麻醉苏醒单`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_hide_right`,
                    label: `是否隐藏右侧体征栏`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `time`,
                    prop: `first_surgery_time`,
                    label: `首台时间`,
                    width: `120`,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    default: `08:00`
                },
                {
                    type: `float`,
                    prop: `default_surgery_long`,
                    label: `默认手术时长(小时)`,
                    width: `120`,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    default: 2
                },
                {
                    type: `string`,
                    prop: `qr_code`,
                    label: `条码号`,
                    width: `100`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default`
                        }
                    ],
                    fixed: `right`
                }
            ]
        }
    },
    mounted() {},
    methods: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/OperationRoom/Index.vue